import React from 'react'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: string
  elevated?: boolean
}

export const Card: React.FC<CardProps> = ({ padding = '1.5rem', elevated = false, style, children, ...rest }) => (
  <div style={{ background: elevated ? 'var(--bg-elevated)' : 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding, ...style }} {...rest}>
    {children}
  </div>
)
